import { render } from "./basic-info.vue?vue&type=template&id=f8c4a07c&scoped=true"
import script from "./basic-info.vue?vue&type=script&lang=js"
export * from "./basic-info.vue?vue&type=script&lang=js"

import "./basic-info.vue?vue&type=style&index=0&id=f8c4a07c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8c4a07c"]])

export default __exports__